var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 2.6H2.66667V4.55H9.33333V2.6H10.6667V5.85H12V1.3H7.88C7.6 0.546 6.86667 0 6 0C5.13333 0 4.4 0.546 4.12 1.3H0V13H5.33333V11.7H1.33333V2.6ZM6 1.3C6.36667 1.3 6.66667 1.5925 6.66667 1.95C6.66667 2.3075 6.36667 2.6 6 2.6C5.63333 2.6 5.33333 2.3075 5.33333 1.95C5.33333 1.5925 5.63333 1.3 6 1.3Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.825L8.34 10.4L6.33333 8.45L5.33333 9.425L8.34 12.35L13 7.8L12 6.825Z",
    fill: "current"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.96812409.svg";
export { ForwardRef as ReactComponent };